module.exports = __webpack_public_path__ + "static/img/sy-2.4c8a7cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-2.png
// module id = 8jxb
// module chunks = 63